/**
 * @description Sticky header height
 * @module stickyHeaderHeightMap
 * @category config
 */

import {
    EXTRA_LARGE,
    LARGE,
    MEDIUM,
    SMALL
} from 'widgets/toolbox/viewtype';

export const stickyHeaderHeightMap = {
    [SMALL]: 64,
    [MEDIUM]: 64,
    [LARGE]: 122,
    [EXTRA_LARGE]: 122
};
